import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const _isFalsy = (val) =>
_.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = (val) => !_isFalsy(val)

const requestCancel = {
    token: Vue.axios.CancelToken,
    source: null
}

const hotline = {
    namespaced: true,

    state: {
      customers:[],
      searchFilters:{
        agencies:[],
        paginate:0,
      },
      messages:[],
      customer_messages:[],
      messagesFilters:{},
      is_fetching:false,
      errors:[],
      contracts:[],
    },

    mutations: {
      [types.HOTLINE_CUSTOMERS_RECEIVED](state, payload){
          state.customers = payload.customers
      },
      [types.HOTLINE_SEARCH_FILTERS_UPDATED](state, payload){
        Object.assign(state.searchFilters, payload)
      },

      [types.HOTLINE_MESSAGES_CREATED](state, payload){
        console.log("An hotline message has been stored.")
      },
      [types.HOTLINE_MESSAGE_EDITED](state, payload)
      {
        console.log("An hotline message has been updated.")
      },
      [types.HOTLINE_MESSAGE_ARCHIVED](state, payload)
      {
        console.log("An hotline message has been archived.")
      },
      [types.HOTLINE_MESSAGE_UNARCHIVED](state, payload)
      {
        console.log("An hotline message has been UN-archived.")
      },
      [types.HOTLINE_MESSAGES_RECEIVED](state, payload)
      {
        console.log("All hotline messages have been fetched.")
        state.messages = payload.hotline_messages
      },
      [types.HOTLINE_CUSTOMERS_MESSAGES_RECEIVED](state, payload)
      {
        console.log("All hotline messages of a customer have been fetched.")
        state.customer_messages = payload
      },
      [types.HOTLINE_MESSAGE_RECEIVED](state, payload)
      {
        console.log("An hotline message has been fetched.")
      },
      [types.HOTLINE_CONTRACTS_RECEIVED](state, payload)
      {
        console.log("Customer's contracts have been fetched.")
        state.contracts = payload.contracts
        // console.warn(payload)
      },
    },

    actions: {

      updateSearchFilters({commit, state}, newFilters) {
        commit(types.HOTLINE_SEARCH_FILTERS_UPDATED, newFilters)
      },

      customersByKeywords({commit, state}, params) {
        return api.hotline_search_customers(params)
                  .then((response) => commit(types.HOTLINE_CUSTOMERS_RECEIVED, response.data))
                  .catch((error) => state.errors.push(error.response))
      },

      fetch_all_hotline_messages({commit, state}, params)
      {
        params = _.assign(params, {per_page:5, with:"creating_user;customer", orderBy:"calling_date",sortedBy:"desc"})
        return api.get_hotline_messages({params})
                  .then((response) => {
                    commit(types.HOTLINE_MESSAGES_RECEIVED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response)
                  })
      },

      fetch_hotline_messages_of({commit, state}, params)
      {
        return api.get_customer_hotline_messages(params)
                  .then((response) => {
                    commit(types.HOTLINE_CUSTOMERS_MESSAGES_RECEIVED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response)
                  })
      },

      fetch_an_hotline_message({commit, state}, params)
      {
        return api.get_customer_hotline_message(params)
                  .then((response) => {
                    commit(types.HOTLINE_MESSAGE_RECEIVED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response)
                  })
      },

      create_hotline_message({commit, state}, params)
      {
        return api.post_hotline_message(params)
                  .then((response) => {
                    commit(types.HOTLINE_MESSAGES_CREATED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response.data.errors)
                  })
      },

      update_hotline_message({commit, state}, params)
      {
        return api.put_hotline_message(params)
                  .then((response) => {
                    commit(types.HOTLINE_MESSAGE_EDITED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response)
                  })
      },

      archive_message({commit, state}, params)
      {
        return api.archive_hotline_message(params)
                  .then((response) => {
                    commit(types.HOTLINE_MESSAGE_ARCHIVED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response)
                  })
      },

      unarchive_message({commit, state}, params)
      {
        return api.unarchive_hotline_message(params)
                  .then((response) => {
                    commit(types.HOTLINE_MESSAGE_UNARCHIVED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response)
                  })
      },

      set_fetching_state({state}, flag)
      {
        state.is_fetching = flag
      },

      reset_datas({state}) {
        state.customers=[]
        state.messages=[]
        state.customer_messages=[]
        state.is_fetching=false
        state.errors=[]
      },

      reset_error({rootState}){
        rootState.formError = {}
      },

      reset_hotline_errors({state}){
        state.errors = []
      },

      reset_customers({state})
      {
        state.customers = []
      },

      contractsCustomer({state, commit}, params)
      {
        return api.get_hotline_contracts(params)
                  .then((response) => {
                      commit(types.HOTLINE_CONTRACTS_RECEIVED, response.data)
                  })
                  .catch((error) => {
                    state.errors.push(error.response.data.errors)
                  })
      },

      resetContracts({state}, ctcs)
      {
        state.contracts = ctcs
      },

    },

    getters:{
        selectAgenciesList (state, getters, rootState) {
            return _.chain(rootState.agencies)
            // .filter(['archived', false])
                .map(
                    (agency) => ({
                        id: agency.id,
                        text: agency.display_name
                    })
                ).value()
        },

        userAgenciesIdList (state, getters, rootState) {
            return _.map(
                rootState.user.agencies,
                (agency) => "" + agency.id
            )
        },

        messages(state){
          return state.messages
        },

        customer_messages(state)
        {
          return state.customer_messages
        },

        any_errors(state)
        {
          return state.errors.length > 0
        },

        errors(state)
        {
          return state.errors
        },

        contracts(state)
        {
          return _.filter(state.contracts, ctc => {
            let flag = false
            _.each(ctc.contract_options, cto => {
              if (cto.option.simple_hotline && _.includes(['active', 'pending-termination'], cto.status))
                flag = true
            })
            return flag
          })
        },

        customers(state)
        {
          return _.map(state.customers, customer => {
            let identity = customer.main_representative.decoded_civility != null ? customer.main_representative.decoded_civility : ""
            if (customer.main_representative.first_name != null)
              identity += " " + customer.main_representative.first_name
            if (customer.main_representative.last_name  != null)
              identity += " " + customer.main_representative.last_name
            if (customer.main_representative.decoded_representative_quality != null)
              identity += " (" + customer.main_representative.decoded_representative_quality + ")"
            return {
              id:customer.id,
              name:customer.name + " / " + identity
            }
          })
        }
    }
}

export default hotline



// WEBPACK FOOTER //
// ./client/store/modules/hotline.js